<template>
  <router-link
    :to="{name: 'push_info', params: {pushId: pushId}}"
  >
    Push {{pushId}}
  </router-link>
</template>

<script>
export default {
  name: 'PushLink',

  props: {
    pushId: {
      type: Number,
      required: true,
    }
  },
};
</script>
